import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTerritory = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 39.82 39.82",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:currentColor;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "Asset 1" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			"data-name": "Layer 2",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Layer_1-2",
				"data-name": "Layer 1",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M19.91,13.27a6.64,6.64,0,0,0-6.64,6.64,6.64,6.64,0,0,0,6.64,6.64,6.64,6.64,0,0,0,6.64-6.64,6.64,6.64,0,0,0-6.64-6.64Zm0,16.59a9.59,9.59,0,0,1-7-2.92,9.59,9.59,0,0,1-2.92-7,9.59,9.59,0,0,1,2.92-7,9.59,9.59,0,0,1,7-2.92,9.59,9.59,0,0,1,7,2.92,9.59,9.59,0,0,1,2.92,7A9.59,9.59,0,0,1,27,27,9.59,9.59,0,0,1,19.91,29.87Zm0-23.23a12.79,12.79,0,0,0-9.39,3.89,12.79,12.79,0,0,0-3.89,9.39,12.79,12.79,0,0,0,3.89,9.39,12.79,12.79,0,0,0,9.39,3.89A12.79,12.79,0,0,0,29.3,29.3a12.79,12.79,0,0,0,3.89-9.39,12.79,12.79,0,0,0-3.89-9.39A12.79,12.79,0,0,0,19.91,6.64Zm11.73,25a16.75,16.75,0,0,1-5.29,3.54,16.36,16.36,0,0,1-12.89,0,16.36,16.36,0,0,1-8.83-8.83,16.36,16.36,0,0,1,0-12.89,16.36,16.36,0,0,1,8.83-8.83,16.36,16.36,0,0,1,12.89,0,16.36,16.36,0,0,1,8.83,8.83,16.36,16.36,0,0,1,0,12.89A16.75,16.75,0,0,1,31.64,31.64Zm-1.74-29A19.48,19.48,0,0,0,19.91,0a19.48,19.48,0,0,0-10,2.67A19.82,19.82,0,0,0,2.67,9.92,19.48,19.48,0,0,0,0,19.91a19.48,19.48,0,0,0,2.67,10,19.82,19.82,0,0,0,7.25,7.25,19.48,19.48,0,0,0,10,2.67,19.48,19.48,0,0,0,10-2.67,19.82,19.82,0,0,0,7.25-7.25,19.48,19.48,0,0,0,2.67-10,19.48,19.48,0,0,0-2.67-10A19.83,19.83,0,0,0,29.91,2.67Z"
				})
			})
		})
	]
});
export default SvgIconTerritory;
